// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"8576245e","198":"d6613af0","404":"fe07ae8c","498":"de3e24f6"}[chunkId] + ".chunk.js";
};